module.exports = __webpack_public_path__ + "img/slide.4dbd74b3.png";